import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import { Container } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const AssignedEssays = () => {
  const [assignedEssays, setAssignedEssays] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAssignedEssays = async () => {
      try {
        const response = await axios.get('https://backend.writerswright.com/api/v1/teacher/getAssignedEssays?Id=5');
        setAssignedEssays(response.data);
      } catch (error) {
        console.error('Error fetching assigned essays:', error);
      }
    };

    fetchAssignedEssays();
  }, []);

  const navigateToEssayDetails = (Id) => {
    Cookies.set('essayId', Id);
    navigate('/teachers-portal/essays-details-teacher'); // Navigate to EssayDetails page
  };

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3 alltitles">
        <h2 className="titleone">Assigned Essays</h2>
      </div>
      <div className="tables">
        <Table bordered>
          <thead>
            <tr>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Sr
              </th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Student
              </th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Email
              </th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Status
              </th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Download
              </th>
              <th style={{ color: 'var(--primary)', fontWeight: 'bold' }} className="text">
                Details
              </th>
            </tr>
          </thead>
          <tbody>
            {assignedEssays.map((essay, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{essay.studentName}</td>
                <td>{essay.studentEmail}</td>
                <td>{essay.essayStatus}</td>
                <td>
                  <a href={`https://backend.writerswright.com/${essay.essayDocument}`} style={{ color: 'black' }}>
                    Download Document
                  </a>
                </td>
                <td>
                  <button
                    onClick={()=>{navigateToEssayDetails(essay.Id)}}
                    style={{ color: 'black', background: 'none', border: 'none', textDecoration: 'underline' }}
                  >
                    View More
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Container>
  );
};

export default AssignedEssays;
